export default __webpack_public_path__ + "static/media/ce_notes.f32d4881.png";